import type { IconSpec } from "./icon";

export type ActionSpecStatus =
    | { type: "ENABLED" }
    | { type: "DISABLED"; reason: string };

interface ActionSpecBase {
    id: string;
    label: string;
    icon: IconSpec;
    status?: ActionSpecStatus;
}

interface LinkHref {
    href: string;
}

interface LinkTo {
    to: string;
}

export interface ActionLink {
    link: LinkHref | LinkTo;
}

export interface ActionClick {
    onClick: () => void;
}

export interface ActionDropdownItem {
    key: string;
    title: string;
    description: string;
    action: {
        link?: LinkHref;
        onClick?: () => void;
    };
}

interface ActionDropdown {
    type: "Dropdown";
    items: ActionDropdownItem[];
}

export type ActionLinkSpec = ActionSpecBase & ActionLink;
export type ActionClickSpec = ActionSpecBase & ActionClick;
export type ActionDropdownSpec = ActionSpecBase & ActionDropdown;

export type ActionSpec = ActionLinkSpec | ActionClickSpec | ActionDropdownSpec;

export function actionMenuStatus(
    enabled: boolean,
    reason: string
): ActionSpecStatus {
    return enabled ? { type: "ENABLED" } : { type: "DISABLED", reason };
}
